import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { db } from "./firebaseConfig";
import { doc, getDoc, updateDoc } from "firebase/firestore";
import Navbar from "./Navbar";
import "./Edit.css";

const EditFlashcards = () => {
    const { quizId } = useParams();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [flashcardSet, setFlashcardSet] = useState(null);

    useEffect(() => {
        const fetchFlashcards = async () => {
            const quizRef = doc(db, "quizzes", quizId);
            const quizSnap = await getDoc(quizRef);
            if (quizSnap.exists()) {
                setFlashcardSet(quizSnap.data());
            }
            setLoading(false);
        };
        fetchFlashcards();
    }, [quizId]);

    const handleInputChange = (field, value) => {
        setFlashcardSet(prev => ({ ...prev, [field]: value }));
    };

    const handleFlashcardChange = (index, side, value) => {
        const updatedCards = [...flashcardSet.flashcards];
        updatedCards[index][side] = value;
        setFlashcardSet(prev => ({ ...prev, flashcards: updatedCards }));
    };

    const addFlashcard = () => {
        setFlashcardSet(prev => ({
            ...prev,
            flashcards: [...prev.flashcards, { front: "", back: "" }]
        }));
    };

    const removeFlashcard = (idx) => {
        const updatedCards = flashcardSet.flashcards.filter((_, i) => i !== idx);
        setFlashcardSet(prev => ({ ...prev, flashcards: updatedCards }));
    };

    const handleSave = async () => {
        const quizRef = doc(db, "quizzes", quizId);
        await updateDoc(quizRef, flashcardSet);
        alert("Flashcards updated successfully!");
        navigate("/dashboard");
    };

    if (loading) return <p>Loading...</p>;

    return (
        <>
            <Navbar />
            <div className="container">
                <h2 className="title">Edit Flashcards</h2>

                <div className="form-group">
                    <label>Title:</label>
                    <input
                        type="text"
                        value={flashcardSet.title}
                        onChange={e => handleInputChange("title", e.target.value)}
                    />
                </div>

                <div className="form-group">
                    <label>Description:</label>
                    <textarea
                        value={flashcardSet.description}
                        onChange={e => handleInputChange("description", e.target.value)}
                    />
                </div>

                <div className="form-group checkbox-group">
                    <label>Public:</label>
                    <input
                        type="checkbox"
                        checked={flashcardSet.public}
                        onChange={e => handleInputChange("public", e.target.checked)}
                    />
                </div>

                <div className="flashcard-section">
                    <h3 className="section-title">Flashcards:</h3>
                    {flashcardSet.flashcards.map((card, idx) => (
                        <div key={idx} className="flashcard-card">
                            <div className="form-group">
                                <label>Front:</label>
                                <input
                                    type="text"
                                    value={card.front}
                                    onChange={(e) => handleFlashcardChange(idx, "front", e.target.value)}
                                />
                            </div>

                            <div className="form-group">
                                <label>Back:</label>
                                <input
                                    type="text"
                                    value={card.back}
                                    FonChange={(e) => handleFlashcardChange(idx, "back", e.target.value)}
                                />
                            </div>

                            <button className="remove-btn" onClick={() => removeFlashcard(idx)}>Remove Flashcard</button>
                        </div>
                    ))}
                    <button className="add-btn" onClick={addFlashcard}>Add Flashcard</button>
                </div>
                <button className="submit-btn" onClick={handleSave} style={{ marginLeft: "50px", marginTop: "20px" }}>Save Changes</button>
                <button className="cancel-btn" type="button" onClick={() => navigate("/dashboard")}>Cancel</button>
            </div>
        </>
    );
};

export default EditFlashcards;
